var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1912_25032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 10.6654C5.33325 9.25088 5.89515 7.89432 6.89535 6.89413C7.89554 5.89393 9.2521 5.33203 10.6666 5.33203H21.3333C22.7477 5.33203 24.1043 5.89393 25.1045 6.89413C26.1047 7.89432 26.6666 9.25088 26.6666 10.6654V21.332C26.6666 22.7465 26.1047 24.1031 25.1045 25.1033C24.1043 26.1035 22.7477 26.6654 21.3333 26.6654H10.6666C9.2521 26.6654 7.89554 26.1035 6.89535 25.1033C5.89515 24.1031 5.33325 22.7465 5.33325 21.332V10.6654Z",
    stroke: "#29AB87",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16C12 17.0609 12.4214 18.0783 13.1716 18.8284C13.9217 19.5786 14.9391 20 16 20C17.0609 20 18.0783 19.5786 18.8284 18.8284C19.5786 18.0783 20 17.0609 20 16C20 14.9391 19.5786 13.9217 18.8284 13.1716C18.0783 12.4214 17.0609 12 16 12C14.9391 12 13.9217 12.4214 13.1716 13.1716C12.4214 13.9217 12 14.9391 12 16Z",
    stroke: "#29AB87",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10V10.0133",
    stroke: "#29AB87",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1912_25032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagramIcon);
export default __webpack_public_path__ + "static/media/footer-instagram-icon.43e0a3194e44f68c9018294da03bfe7f.svg";
export { ForwardRef as ReactComponent };